import React from 'react';

import { TasksProvider } from './context/provider';
import { TasksFilters } from './components/filters';
import { TasksList } from './components/list';
import { TasksModal } from './components/modal';
import { TasksNewButton } from './components/new_button';
import { TasksPageCount } from './components/tasks_page_count';
import { TasksPagination } from './components/pagination';
import { TasksQuickFilters } from './components/quick_filters';

import type { ReactNode } from 'react';
import type { ForUser } from 'bundles/apex/tasks/types';
import type { Parent } from 'bundles/crm/types';
import type { Props as TaskProps } from './task';
import type { TasksFiltersProps } from './components/filters';

import './styles.scss';

export { useTasks } from './context/tasks_context';
export type { TasksFiltersProps } from './components/filters';

// TODO: Consistent props (hide vs show) would be nice...
export interface Props {
  children: ReactNode;
  currentParent?: Parent;
  features?: TaskProps['features'];
  filters: TasksFiltersProps;
  forUser: ForUser;
  hideAssignees?: boolean;
  options?: {
    assignees?: [];
    parents?: [];
  };
  paginate?: boolean;
  paths: {
    attachments: string;
    checkForImmediateReminders: string;
    create?: string;
    formDependenciesPath: string;
  };
  showParents?: TaskProps['showParents'];
  showRouterPrompt?: boolean;
}

function Tasks({
  children,
  currentParent,
  features,
  filters,
  forUser,
  hideAssignees = false,
  options = {},
  paginate,
  paths,
  showParents,
  showRouterPrompt,
}: Props) {
  return (
    <TasksProvider
      currentParent={currentParent}
      features={features}
      filtersConfig={filters}
      forUser={forUser}
      hideAssignees={hideAssignees}
      options={options}
      paginate={paginate}
      paths={paths}
      showParents={showParents}
      showRouterPrompt={showRouterPrompt}
    >
      {children}
      <TasksModal />
    </TasksProvider>
  );
}

Tasks.Filters = TasksFilters;
Tasks.List = TasksList;
Tasks.NewButton = TasksNewButton;
Tasks.PageCount = TasksPageCount;
Tasks.Pagination = TasksPagination;
Tasks.QuickFilters = TasksQuickFilters;

export default Tasks;
